import { useParams, useNavigate, Navigate } from "react-router-dom";
import { useEffect } from "react";
import { useScrollToTop } from "@/hooks/useScrollToTop";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ProductImageZoom from "./components/ProductImageZoom";
import ProductInfo from "./components/ProductInfo";
import RelatedPieces from "./components/RelatedPieces";
import { collectionsData } from "@/mocks/collections";

export default function ProductDetail() {
  useScrollToTop();
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  // Fallback scroll to top on mount
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, []);

  const product = collectionsData.find((p) => p.slug === id);

  if (!product) {
    return <Navigate to="/collections" replace />;
  }

  return (
    <div className="min-h-screen bg-brand-cream font-sans">
      <Navbar />
      <main className="pt-20 md:pt-24">
        {/* Breadcrumb */}
        <div className="max-w-7xl mx-auto px-6 py-6">
          <div className="flex items-center gap-3 text-xs font-display tracking-widest uppercase text-brand-muted">
            <button
              onClick={() => navigate("/")}
              className="hover:text-brand-gold transition-colors duration-200 cursor-pointer"
            >
              Home
            </button>
            <span className="text-brand-gold/40">/</span>
            <button
              onClick={() => navigate("/collections")}
              className="hover:text-brand-gold transition-colors duration-200 cursor-pointer"
            >
              Collections
            </button>
            <span className="text-brand-gold/40">/</span>
            <span className="text-brand-brown">{product.name}</span>
          </div>
        </div>

        {/* Product Detail */}
        <section className="max-w-7xl mx-auto px-6 pb-20">
          <div className="flex flex-col lg:flex-row gap-12 lg:gap-16">
            {/* Image Section */}
            <div className="w-full lg:w-3/5">
              <ProductImageZoom
                src={product.image}
                alt={product.name}
                images={product.images}
              />
            </div>

            {/* Info Section */}
            <div className="w-full lg:w-2/5">
              <ProductInfo product={product} />
            </div>
          </div>
        </section>

        {/* Related Pieces */}
        <RelatedPieces currentSlug={product.slug} category={product.category} />
      </main>
      <Footer />
    </div>
  );
}
